import { RoleEnum } from '../../../../utils/select-state/RoleEnum'

export const getCheckAvailabilityCallbackFake = (role: RoleEnum | undefined): (() => boolean) => {
  return () => {
    return role === RoleEnum.MENTOR
  }
}
